export const locale = {
  lang: 'nl',
  data: {
    'REQUERIMIENTOS': {
      'BOTONES':{
        'SIGUIENTE': 'Volgende',
        'ANTERIOR': 'Vorige',
        'FINALIZAR': 'Voltooien',
        'ACEPTAR': 'Ik aanvaard de technische vereisten'
      },
      'MENSAJES': {
        'CONFREQ': 'U hebt de technische eisen van het platform met succes aanvaard',
        'OK': 'OK',
      },
      'CABECERA':{
        'TITULO': 'IT-behoeften',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipiserende elite,'
      },
      'PASO1':{
        'TITULO': 'Collaborator Requirements',
        'SUB_TITULO': '1. Toepassingsvereisten',
        'SUB_TITULO2': '2. Vereisten voor de capaciteit van de browser',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS': 'Besturingssystemen',
          'TD_LABEL_RECOMENDADO': 'of hoger. (AANBEVOLEN)',
          'TD_NAVEGADOR': 'Browser',
          'TD_LABEL_SUPERIOR': 'of hoger',
          'TD_LABEL_LASTVERSION': '(laatste versie)',
          'TD_LABEL_LASTVERSION_MIN': '(laatste versie, minimale versie 12.3)'
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR': 'Veiligheidscertificaat',
          'TD_COOKIES': 'Cookies toegestaan',
          'TD_CIFRADO': 'TLS-codering',

          'TD_CONTENT1': 'Zorg ervoor dat het veiligheidscertificaat of de veiligheidsautoriteit de door uw organisatie als betrouwbaar geclassificeerde Lets Encrypt Authority X3 toekent',
          'TD_CONTENT2': 'De browser moet JavaScript 1.2 hebben ingeschakeld',
          'TD_CONTENT3': 'De servers van het CulturalGo Platform werken met cookies, die geen informatie van de gebruiker of zijn besturingssysteem verzamelen. Maar ze zijn wel nodig voor de werking van de enquête en moeten worden ingeschakeld.',
          'TD_CONTENT4': 'Afhankelijk van het type project is voor een van onze rapportmodules alleen TLS-codering nodig'
        },
        'PARRAFO1': {
          'SUBPARRAFO1': 'Als de klant van plan is om andere besturingssystemen zoals LINUX, UNIX, ChromeOS of mobiele platforms te gebruiken, is de klant verantwoordelijk om ervoor te zorgen dat zijn browsersoftware goed werkt met de enquête',
          'SUBPARRAFO2': 'In reactie op de POODLE Vulnerability (CVE-2014-3566) en de beëindiging van de ondersteuning voor Windows XP door Microsoft, zal Great Place de toegang tot onze beveiligde websites vanaf computers met Windows XP niet langer volledig ondersteunen. Great Place zal de ondersteuning voor Windows XP-computers handhaven met behulp van versies van Chrome of Firefox-browsers die in de toepassingsvereisten staan vermeld. Het is mogelijk dat andere browsers nog steeds toegang bieden; deze browsers worden echter niet getest of ondersteund.'
        },
        'ADVERT': 'OPMERKING: Vanaf versie 5.0 van Cultural Go is de ondersteuning voor Microsoft Internet Explorer verwijderd'
      },
      'PASO2':{
        'TITULO': 'Enquête-authenticatie',
        'SUB_TITULO1': '3. Certificaten',
        'SUB_TITULO2': '4. Collaborators laptop / computer',
        'SUB_TITULO3': '5. Enquêtereactie van mobiele apparaten',
        'SUB_TITULO4': '1. Te overwegen kwesties',
        'SUB_TITULO5': '2. Taalhulp',
        'PARRAFO1': 'Culturele GO maakt gebruik van Lets Encrypt Authority X3 SSL-certificaat van de Internet Security Research Group (ISRG). Als het certificaat niet is geïnstalleerd, wordt er een beveiligingswaarschuwingspagina aan de gebruiker getoond met de melding dat er een probleem is met het beveiligingscertificaat van de website. De gebruiker kan ervoor kiezen om door te gaan met de toegang tot de website of om meer informatie over het probleem weer te geven. Ook al is het de gebruiker toegestaan om op de website te navigeren, het waarschuwingsbericht zal elke keer dat de gebruiker de website bezoekt blijven verschijnen.',
        'PARRAFO2':{
          'LINEA1': 'Om toegang te krijgen tot de online enquête heeft de computer/laptop van de werknemer nodig:',
          'LINEA2': 'Volledige toegang tot het webadres van de enquête (zorg ervoor dat de gebruiker de juiste rechten heeft in geval van een firewall)',
          'LINEA3': 'In het geval dat de enquête LINK wordt gemaild, moet de gebruiker toegang hebben tot zijn zakelijke e-mailaccount',
        },
        'PARRAFO3': 'De enquêtes zijn gevalideerd op mobiele apparaten zoals tablets en telefoons. De presentatie en rangschikking van de enquête-elementen wordt afgestemd op de resolutie van het schermtoestel. Het hangt af van het model van het apparaat voor de uit te voeren enquête',

        'PARRAFO4': 'De enquête is ontworpen om een aangename gebruikerservaring te hebben op de verticale schermen van mobiele apparaten met Full HD-resolutie',

        'PARRAFO5': 'In verschillende organisaties geven wifi-netwerken geen volledige toegang tot persoonlijke apparaten, dus als de gebruiker besluit om zijn persoonlijke apparaat te gebruiken en verbinding te maken via een wifi-netwerk, moet hij valideren dat hij toegang heeft tot de enquêtewebsite',

        'PARRAFO6': 'De gebruiker dient er rekening mee te houden dat als hij een directe verbinding met zijn mobiele telefoonmaatschappij gebruikt, er mogelijk navigatiekosten in rekening worden gebracht',
        'PARRAFO7':{
          'LINEA1': 'Gebruikers krijgen toegang tot de site door gebruik te maken van een specifieke URL die per project wordt gegenereerd. Links hebben geen informatie van de gebruiker.',
          'LINEA2': 'Een unieke gebruikerscode moet worden ingevoerd in de beveiligde globale URL om toegang tot de enquête mogelijk te maken',
          'LINEA3': 'Elke unieke gebruikerscode wordt aan gebruikers verstrekt, hetzij via e-mail, SMS, of handmatig via Human Resources Manager (of een gelijkwaardige functie)',
        },
        'PARRAFO8':{
          'LINEA1':'1. De klant moet de levering van de uitnodiging via e-mail aan zijn medewerkers controleren:',
          'LINEA2':'Als de e-mailserver wordt uitbesteed, neem dan vooraf contact op met de e-mailprovider om de vereisten te informeren',
          'LINEA3': 'Als de e-mailserver in hun faciliteiten staat, vraag dan om ondersteuning van de IT-afdeling',
          'LINEA4':'Let op: Bij het verzenden van de uitnodigingen om de enquête te beantwoorden, wordt geen gratis dienst als verstuurd: Hotmail, Gmail, Yahoo, etc.',
          'LINEA5': '2. Als de zakelijke e-mail van de klant OUTLOOK WEBACCESS is, moeten de medewerkers de weblink kopiëren en openen in de webbrowser, anders wordt er een fout gegenereerd',
          'LINEA6':'3. Als u de enquête langer dan 30 minuten inactief laat op de computer of het apparaat waar de enquête wordt uitgevoerd, wordt een TIME OUT gegenereerd, waarbij u zich opnieuw moet registreren in de enquête, met dezelfde gebruiker en hetzelfde wachtwoord. Het systeem brengt gebruikers naar de exacte vraag waar ze zich bevonden',
          'LINEA7': 'Elk antwoord wordt opgeslagen wanneer het wordt geselecteerd. De gebruiker zal geen andere antwoorden kunnen selecteren totdat het opslagproces is voltooid, zodat de vooruitgang van de gebruiker bij het beantwoorden van de enquête betekent dat alle geselecteerde antwoorden zijn opgeslagen',
        },
        'PARRAFO9':{
          'LINEA1': 'Onze enquête ondersteunt alleen de talen die zijn ingesteld in de taalkiezer en kan alleen aan het begin van de enquête worden geselecteerd',
          'LINEA2': 'Indien de geselecteerde talen in een andere taal zijn die speciale tekens vereist, moet de gebruiker ervoor zorgen dat zijn browser de lettertypes ondersteunt',
          'LINEA3': 'Normaal gesproken hebben alle gebruikers die van plan zijn de enquête te bekijken in een Oost-Aziatische taal of een andere taal die speciale karakters vereist, al taalpakketten geïnstalleerd, dus dit hoeft niet voor alle gebruikers te worden gedaan, behalve voor een paar',
          'LINEA4': 'Voor elk project dat specifiek vereist is om een specifiek lettertype op de online site te gebruiken, moeten de gebruikers dat specifieke lettertype op elk van hun respectievelijke machines geïnstalleerd hebben. Wanneer dat nodig is, zal Great Place dergelijke eisen aan het projectteam van de klant communiceren.',
        },
        'PARRAFO10': 'Belangrijk: De gebruiker moet ervoor zorgen dat de browser niet de automatische vertaalfunctie actief heeft, anders werkt de taalkiezer mogelijk niet',
      },
      'PASO3':{
        'TITULO': 'Vereisten voor een internetverbinding',
        'SUB_TITULO1': '1. SSL-versleutelingseisen',
        'SUB_TITULO2': '2. Vereiste bandbreedte',
        'SUB_TITULO3': '3. Firewall Whitelists: ',
        'SUB_TITULO4': '4. Webserver IP en domeintoegang',
        'SUB_TITULO5': '5. Opwekking van antwoordgroepen (Kioskos)',
        'PARRAFO1': 'De webbrowser van de klant moet sites met SSL ondersteunen. Dit maakt het mogelijk om de gebruiker maximale privacy van gepersonaliseerde informatie te geven.',

      'PARRAFO2': 'De bandbreedte is afhankelijk van het type onderzoek en rapporten dat wordt uitgevoerd en de componenten - video, flash en beelden - die in de oplossing worden gebruikt. Voor enquêtes met deze componenten is de aanbevolen verbinding 1+ Mbit/s per gebruiker. De bruikbaarheid zal worden beïnvloed als er een lagere verbinding wordt gebruikt. Voor enquêtes met geen van deze componenten is een normale verbinding met het internet nodig.',
        'PARRAFO3':{
          'LINEA1': 'De volgende sites moeten op de witte lijst worden gezet voor de enquête en de rapportage over Cultural Go:',
          'LINEA2': 'Het is belangrijk om de benodigde rechten te verlenen aan de volgende domeinen en IP-adressen, zodat medewerkers toegang hebben tot de Great Place to Work® Trust Index ©survey',
        },
        'PARRAFO31': 'Belangrijk: Het hele domein moet beschikbaar zijn voor de gebruikers (moet toegang verlenen tot de hele site)',
        'PARRAFO4':{
          'LINEA1': 'De mailserver vereist volledige toegang tot de volgende e-mailadressen:',
          'LINEA2': 'Het is noodzakelijk dat de volgende rechten worden verleend op uw mailserver om te voorkomen dat e-mails van Great Place als SPAM worden geclassificeerd:',
        },
        'PARRAFO5':{
          'LINEA1': 'Belangrijk:',
          'LINEA2':'Deze opzet is om te voorkomen dat het e-mailadres wordt gedetecteerd als SPAM',
          'LINEA3': 'De mailserver moet duizenden e-mails kunnen krijgen van dezelfde account',
          'LINEA4': 'Voeg in de beveiligingsregels van uw e-mailprovider de domeinen voor whitelisting toe, en voeg ze indien mogelijk toe als contact-e-mailaccounts',
        },
        'PARRAFO6': 'In een groot aantal organisaties is het gebruikelijk om meerdere computers te plaatsen, zodat gebruikers de enquêtes in groepsverband kunnen beantwoorden. Het is dus noodzakelijk om de bandbreedte van de uitgangen naar het internet te testen om er zeker van te zijn dat de verbindingsapparaten al het verkeer dat door de respons in groepen wordt gegenereerd, zullen ondersteunen',
        'PARRAFO7': 'Het wordt aanbevolen dat, voordat gebruikers in groepsverband gaan antwoorden, een IT-specialist controleert of er geen problemen met de internetverbinding zullen zijn',
        'TABLA1':{
          'TD_ELEMENTO': 'Element',
          'TD_REGION1': 'Regio México',
          'TD_REGION2': 'Regio Midden- en Zuid-Amerika',
          'TD_REGION3': 'Regio Azië',
          'TD_REGION4': 'Regio Europa',
          'TD_DOMINIO': 'Domein',
          'TD_SUBDOMINIO': 'Sub-domein',
          'TD_DIRECCION': 'IP Direction',
          'TD_PUERTOS': 'Havens',

        },
        'TABLA2':{
          'TD1':'Afzenderpostaccounts:',
          'TD2':'Domein'
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01': 'Toepassing',
          'TD_ELEMENTO02': 'Domein',
          'TD_ELEMENTO03': 'IP',
          'TD_ELEMENTO04': 'Poort',
          'TD_ELEMENTO05': 'Subdomein',
        },
        'TITEL 1':'Domein: CulturalGo.com',
        'TITEL 2': 'Domein: gptw.global',
      },
      'PASO4':{
        'TITULO': 'Service levels',
        'SUB_TITULO1': '1. Ondersteuning',
        'SUB_TITULO2': '2. Beschikbaarheid van het systeem',
        'SUB_TITULO3': '3. Overweldigende kracht',
        'SUB_TITULO4': '4. Concurrentie',
        'SUB_TITULO5': '5. Onderhoudsvenster',
        'TABLA1':{
          'TD_REGION1': 'Regio México',
          'TD_REGION2': 'Regio Midden- en Zuid-Amerika',
          'TD_REGION3': 'Regio Azië',
          'TD_REGION4': 'Regio Europa'
        },
        'PARRAFO1':{
          'LINEA1': 'Beschikbaarheid van de applicatie = 99,5%',
          'LINEA2': 'Om de beschikbaarheid van het systeem te garanderen, wordt de applicatie 24 uur per dag, 7 dagen per week en 365 dagen per jaar bewaakt. Met een waarschuwingssysteem en ondersteunende procedures.',
        },
        'PARRAFO2': 'Overmacht: gebeurtenissen die buiten de redelijke controle van een partij vallen, met inbegrip van, maar niet beperkt tot, daden van God, oorlog, stakingen, overheidsregulering, burgerlijke onlusten of daden van terrorisme of aardbevingen, die het wettelijk onuitvoerbaar, onwettig of onmogelijk maken voor een dergelijke partij om haar taken uit te voeren',
        'PARRAFO3': 'Het serviceniveau van de systeembeschikbaarheid dekt geen enkel gebrek aan service dat wordt veroorzaakt door het feit dat de klant niet voldoet aan de technische vereisten die hierin zijn vastgelegd, of door een gebeurtenis die als overmacht wordt geclassificeerd',
        'PARRAFO4': 'De gegevensverzamelingsomgeving kan 10.000 gelijktijdige gebruikers ondersteunen of tot 1,5 miljoen ingevulde enquêtes in een periode van 24 uur. De rapportage-applicatie kan 500 gelijktijdige gebruikers ondersteunen of tot 1.000 rapportagesessies in een 24-uursperiode',
        'PARRAFO5':{
          'LINEA1': 'Great Place behoudt zich het recht voor om de enquête- en rapportageapplicatie naar beneden te halen voor gepland onderhoud. Geplande onderhoudsschemas zullen vooraf aan alle betrokken partijen worden gecommuniceerd.',
          'LINEA2': 'Tijdens het bovengenoemde onderhoudsvenster is de applicatie mogelijk niet beschikbaar voor gebruikers. Als Great Place een uitgebreid onderhoudsvenster nodig heeft voor aanvullende activiteiten, wordt de aangewezen contactpersoon van de klant hiervan op de hoogte gesteld',
          'LINEA3':'Voor noodonderhoud mag het onderhoudsvenster niet worden aangekondigd. Voor klanten die getroffen zijn door het noodonderhoud, wordt de aangewezen contactpersoon van de klant op de hoogte gesteld.'
        },
      },
      'PASO5':{
        'TITULO': 'Data Privacy Policy',
        'SUB_TITULO1': '1. Beleid',
        'PARRAFO1': 'De informatie die wordt verzonden en opgeslagen op de servers van het CulturalGo Platform wordt beschermd en beveiligd volgens beleid en procedures die in overeenstemming zijn met de bepalingen van ISO 27001. Als u vragen heeft, neem dan contact op met uw adviseur van Great Place To Work',
      },
      'VALIDACION':{
        'TITULO': 'Technische eisen validatie',
        'DATOSTI':{
          'INFOEMPRESA': 'Bedrijfsinformatie',
          'NOMBREEMPRESA': 'Naam van de onderneming',
          'NOMBRE': 'Naam van de IT-manager',
          'EMAIL': 'IT-e-mail',
          'TEL': 'IT-telefoonnummer',
          'EXT': 'Extensie IT-telefoonnummer',
          'CEL': 'Mobiel IT-nummer',
          'TOOLTIP': 'Toon bedrijfsinformatie',
        },
        'TIMELINE':{
          'TITULO': 'validatieproces voor technische vereisten',
          'CARGANDO': 'Laadinformatie',
          'PROGRESO': 'Huidige vooruitgang:',
          'PROGRESO2': 'Technische eisen validatie vooruitgang:',
          'STATUS': {
            'OK': 'Status: Voltooid',
            'NOTOK': 'Status: Niet voltooid',
            'TOOLTIP': 'Markeer als voltooid',
          },
          'COMENTARIO': {
            'TITULO_1': 'Sla een opmerking op over deze stap',
            'INPUT': 'Geef uw commentaar',
            'ENVIAR': 'Bewaar commentaar',
            'TITULO_2': 'Opmerkingen (oudste eerst)',
            'CANNOT': 'Opmerkingen kunnen niet meer worden ingediend zodra de stap is voltooid',
          },
          'NOMBRES': {
            '1': 'E-mail verzonden naar TI manager',
            '2': 'TR opzetten - Klantenbellen',
            '3': 'TR-opstelling - Testen',
            '4': 'Verzending van het vragenformulier',
            '5': 'Vragenformulier afgewerkt',
          }
        },
        'MENSAJES': {
          'NADA': 'U heeft de opmerking nog niet ingevuld, u mag geen lege opmerking opslaan',
          'AUNNO': 'U kunt deze actie nog niet uitvoeren, de technische vereisten moeten eerst worden gevalideerd',
          'COMPLETAR': 'Bevestigt u dat u de status van deze stap als voltooid wilt wijzigen?',
          'COMPLETAR_OK': 'Deze stap is gewijzigd in Voltooid met succes',
          'BOTONEN': {
            'SI': 'Ja',
            'NO': 'Nee',
          },
          'NOCOMPLETAR': 'U mag deze stap niet als voltooid markeren, u moet eerst de vorige stap voltooien',
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK': 'Technische eisen bijgewerkt',
        'MENSAJE_CONEX_OK':'Verbinding succesvol',
        'ACTUALIZANDO_REQUERIMIENTOS': 'Actualisering van de technische voorschriften',
        'MENSAJE_RESPUESTA_REQ': '* Antwoord vereist',
        'WAR_ING_RUN': 'Voer ten minste één e-mail in',
      },
      'CABECERA':{
        'TITULO': 'Technische eisen',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipiserende elite',
      },
       'BOTONES':{
              'SIGUIENTE': 'Volgende',
              'ANTERIOR': 'Vorige',
              'FINALIZAR': 'Voltooien',
              'ACEPTAR': 'Ik accepteer de technische eisen'
            },
        'PASO1':{
          'TITULO': 'Contributor requirements',
          'SUB_TITULO': 'Technische eisen',
          'SUB_TITULO2': 'CulturalGo® 5.0-platform',
          'TEXTO0_PARTE_1': 'het doel van dit document is om te informeren over de technische vereisten van het CulturalGo® -platform om een eenvoudige en effectieve toegang tot het Greate Place to Work®, Trust Index© -enquêtesysteem te garanderen en zo terugkerende technische problemen te voorkomen',
          'TEXTO0_PARTE_2': 'Het is essentieel om te voldoen aan elk van de technische vereisten voor de medewerkers van uw organisatie om de enquête te ontvangen en te beantwoorden. Anders is het zeer waarschijnlijk dat er complicaties zijn zoals blokkades en/of interfaces die ertoe leiden dat de medewerker niet in staat is om de enquête te ontvangen en te beantwoorden',
          'SUB_TITULO3': 'Vereisten voor de bijdrage (eindgebruiker)',
          'SUB_TITULO4': 'Applicatie-eisen',

          'SUB_TITULO2_CARCA': 'CulturalGo® 5.0-platform',
          'TEXTO0_PARTE_1_CARCA': 'het doel van dit document is om te informeren over de technische vereisten van het CulturalGo® -platform om een eenvoudige en effectieve toegang tot het Greate Place to Work®, Trust Index© -enquêtesysteem te garanderen en zo terugkerende technische problemen te voorkomen',
          'TEXTO0_PARTE_2_CARCA': 'Het is essentieel om te voldoen aan elk van de technische vereisten voor de medewerkers van uw organisatie om de enquête te ontvangen en te beantwoorden. Anders is het zeer waarschijnlijk dat er complicaties zijn zoals blokkades en/of interfaces die ertoe leiden dat de medewerker niet in staat is om de enquête te ontvangen en te beantwoorden',
          'TEXTO0_PARTE_1_INNMO': 'het doel van dit document is om te informeren over de technische vereisten van het CulturalGo® -platform om een eenvoudige en effectieve toegang tot het Innmotion, Trust Index© -enquêtesysteem te garanderen en zo terugkerende technische problemen te voorkomen',


          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': 'Besturingssystemen:',
            'TD_LABEL_RECOMENDADO': 'of hoger (AANBEVELD)',
            'TD_NAVEGADOR': 'Browser: ',
            'TD_LABEL_SUPERIOR': 'of hoger',
            'TD_LABEL_LASTVERSIE': '(laatste versie).',
            'TD_LABEL_LASTVERSION_MIN': '(laatste versie, minimale versie 12.3).'
          },
          'TEXTO1_PARTE_1': 'Als de klant van plan is een ander besturingssysteem te gebruiken dan de hierboven genoemde, zoals versies van LINUX, UNIX, Chrome OS, mobiele besturingssystemen, etc., is de klant verantwoordelijk voor het correct uitvoeren van de enquête op zijn browsersoftware',
          'TEXTO1_PARTE_2': 'Vanwege de kwetsbaarheid van POODLE (CVE-2014-3566) en de beëindiging van de ondersteuning voor Windows XP door Microsoft, zal Great Place to Work® de toegang tot onze beveiligde websites vanaf computers met Windows XP niet langer ondersteunen. Great Place to Work® handhaaft de ondersteuning voor computers met Windows XP die gebruik maken van versies van de Chrome of Firefox-browsers die in de toepassingsvereisten staan vermeld. Het is mogelijk dat andere browsers nog steeds toegang bieden; deze browsers worden echter niet getest of ondersteund',
          'TEXTO1_PARTE_2_INNO': 'Vanwege de kwetsbaarheid van POODLE (CVE-2014-3566) en de beëindiging van de ondersteuning voor Windows XP door Microsoft, zal Innmotion de toegang tot onze beveiligde websites vanaf computers met Windows XP niet langer ondersteunen. Innmotion handhaaft de ondersteuning voor computers met Windows XP die gebruik maken van versies van de Chrome of Firefox-browsers die in de toepassingsvereisten staan vermeld. Het is mogelijk dat andere browsers nog steeds toegang bieden; deze browsers worden echter niet getest of ondersteund',
          'TEXTO2_PARTE_1': 'Opmerking: Vanaf versie 5.0 CuturalGo® wordt de ondersteuning voor Microsoft Internet Explorer verwijderd',
        },
        'PASO2':{
          'TITULO': 'Enquête-authenticatie',
          'SUB_TITULO1': 'Web server IP en domeintoegang',
          'SUB_TITULO2': ' Firewall Wissen:',
          'TEXTO0_PARTE_1': 'Het volgende moet op de whitelists staan voor de enquête- en rapportagesites om aan a Platform CulturalGo® te kunnen werken:',
          'TEXTO1_PARTE_1': 'Het is belangrijk om de nodige rechten te verlenen aan de volgende domeinen en IP adressen om uw medewerkers toegang te geven tot de Great Place to Work® Trust Index© enquête',
          'TEXTO1_PARTE_1_INNMO': 'Het is belangrijk om de nodige rechten te verlenen aan de volgende domeinen en IP adressen om uw medewerkers toegang te geven tot de Innmotion Trust Index© enquête',
          'BTN_COMPRO_CONEX':'Controleer verbinding',
          'BTN_SUCCE_CONEX':'Aansluiting tot stand gebracht',
          'TOOL_BTN_COMPRO_CONEX':'Dienst in aanbouw',
          'MODAL_SUCCESS_CONEX':'De verbinding was succesvol',
          'ETI_INTRUC_DOMA_COPY': 'Kopieer en verzend deze link voor het geval u verbindingen moet verifiëren vanaf een gedecentraliseerd toegangspunt (Heeft geen invloed op de validatie van Technische Vereisten).',
          'BTN_INTRUC_COPY_ENLA': 'Kopieer link',
          'MODAL_COPY_ENLA_SUCC': 'Koppeling werd met succes gekopieerd',

          'SUB_TITULO2_CARCA': 'Firewall whilelists:',
          'TEXTO0_PARTE_1_CARCA': 'Het volgende moet op de whitelists staan voor de enquête- en rapportagesites om aan a Platform CulturalGo® te kunnen werken:',
          'TEXTO1_PARTE_1_CARCA': 'Het is belangrijk om de nodige rechten te verlenen aan de volgende domeinen en IP adressen om uw medewerkers toegang te geven tot de Great Place to Work® Trust Index© enquête',


          'TABLE_CONTEN':{
           'TH_ELEMENTO': 'Element',
           'TH_REGIONM': 'Global Region',
           'TH_REGIONC': 'Midden- en Zuid-Amerika',
           'TH_REGIONA': 'Aziatische regio',
           'TH_REGIONE': 'Regio Europa',
           'TH_DOMINIO_PRINCIPAL': 'Hoofddomein',
           'TH_APLICADOR': 'Survey Applicator',
           'TH_PLATAFORMA': 'Administratief platform',
           'TH_ENVOLTURA': 'Url Wrap',
           'TH_RESULTADOS': 'Resultaten (Tableau®)',
           'TH_CULTURE': 'Culture Audit®',
           'TH_PORTAL': 'Extern telportaal',
           'TH_SUBDOMINIO': 'Subdomein',
           'TH_DIRECCION_IP': 'IP-adres',
           'TH_PUERTOS': 'Havens',
           'TH_DOMINIO': 'Domein',
           'TEXTO1':'- Alle koppelingen naar de enquêtes worden geleverd via de URL-wrapper 4all.gptw.global/ , die een doorverwijzing bevat naar de site die voor elk bedrijf is toegewezen. ',
           'TEXTO2':'- Om veiligheidsredenen kunnen de algoritmen van CulturalGo® de URL van de ﬁnnale enquête op elk moment tijdens de enquêteperiode wijzigen. Daarom moet altijd de 4all.gptw.global/-wrapper worden gebruikt, die permanent is gedurende de hele enquête.',
           'TEXTO3':' BELANGRIJK:',
           'TEXTO4':' De enquêtekoppeling mag nooit rechtstreeks worden geopend (bijv. http://newsurvey.culturalgo.com/Ax013s203ls), aangezien het token waaruit de enquête bestaat van tijd tot tijd zonder voorafgaande kennisgeving kan worden gewijzigd',
           'TEXTO5':' Belangrijk:',
           'TEXTO6':' Gebruikers moeten volledige en onbeperkte (onbeperkte) toegang hebben tot het gehele domein. ',
           'TEXTO7':' e-mail server',
           'TEXTO8':' De mailserver vereist volledige toegang tot de volgende e-mailadressen:',
           'TEXTO9':' De volgende rechten zijn vereist op uw mailserver om te voorkomen dat Great Place to Work® e-mails als SPAM naar clasiﬁquen worden verzonden:',
           'TEXTO9_INNMO':' De volgende rechten zijn vereist op uw mailserver om te voorkomen dat Innmotion e-mails als SPAM naar clasiﬁquen worden verzonden:',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO': 'Afzenders-e-mailaccount:',
             'TD_DOMINIO':' Domein:',
             'TD_IP_ADDRE_PRIM':'Primair IP-adres:',
             'TD_SECON_IP':'Secundaire IP-adressen:',
             'TD_SUBDOMINIO':'Subdomeinen voor het omleiden van links (Ze worden gebruikt voor bewaking):',
           },
           'TEXTO10':'- Deze conﬁguración is bedoeld om te voorkomen dat het e-mailadres als spam wordt gedetecteerd. ',
           'TEXTO11':'- De mailserver moet duizenden e-mails kunnen ontvangen van hetzelfde account',
           'TEXTO12':'- Voeg in de beveiligingsregels van uw e-mailprovider de domeinen voor de witte lijst toe en voeg ze indien mogelijk toe als contact-e-mailaccounts',
           'TEXTO13':'Als u ondersteuning nodig heeft, stuur dan een bericht naar',
           'BTN_CONFIGURACION': 'Domeinen en IPs werden geconfigureerd',
           'BTN_ACCESO_ENCUESTA': 'Ik heb de tests uitgevoerd en had geen complicaties',
           'BTN_RECIBI_CORREOS': 'Ik heb de e-mails in mijn inbox ontvangen',

          }
        },
        'PASO3':{
          'TITULO': 'Entreetests',
          'TIT_TES_PRU_ACC_SURV': 'In dit onderdeel kunt u een visualisatietest uitvoeren van een generieke enquête (niet gerelateerd aan uw organisaties):',
          'INS2_TES_PRU_ACC_SURV':'1. Klik op:',
          'INS1_1_TES_PRU_ACC_SURV': 'Kopieer sleutel',
          'INS1_TES_PRU_ACC_SURV':'2. Ga naar de volgende link:',
          'INS3_TES_PRU_ACC_SURV':'3. Plak de sleutel in de wachtwoordcel',
          'INS4_TES_PRU_ACC_SURV':'4. Klik op inloggen',

          'TIT_TES_PRU_EM_PILO': 'In deze sectie kunt u de ontvangst van de mail testen',
          'INS1_TES_PRU_EM_PILO':'1. Voer de e-mails in',
          'INS2_TES_PRU_EM_PILO':'2. Klik op de knop Testmail verzenden',
          'BTN_SE_EMA': 'Verzending van de testmail',
          'CONTAC':'In geval van technische fouten kunt u contact met ons opnemen via support@itbm.mx en wij zullen het graag oplossen.',
          'WARN_TEST_EMAIL':'Om verder te gaan met het proces hebben wij u een bevestigingslink naar uw e-mailadres gestuurd.',
          'MSJ_SUCC_EMA_': 'E-mails werden met succes verzonden',
          'MODAL_WARNI_BAND':'Om verder te gaan met het proces bevestigt u de toegang tot de enquête en/of de ontvangst van de e-mail',
          'MSJ_COP_CLA': 'Gebruikersnaam kopiëren',
          'MODAL_VERIFI_INFO':'Verifiëren van informatie',

          'MODAL_WARNI_EMAL':'IMPORTANT: This link should not be shared with the employees of the organization, because it is a test link in order to validate that the necessary permissions have been granted at the opening of the survey.',
          'CONTAC_CARCA':'In geval van technische fouten kunt u contact met ons opnemen via soporte_ca@gptwonline.com en wij zullen het graag oplossen.',
          'WARN_TEST_EMAIL_CARCA':'Om verder te gaan met het proces hebben wij u een bevestigingslink naar uw e-mailadres gestuurd.',
        },
        'PASO4':{
          'TITULO':'Validatie van de vragenlijst',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿Do I make the settings without any problem?',
            'PREGUNTA_1_INDI':'(If you have had any problems please specify)',
            'PREGUNTA_2':'2.-Your mail server was trusted by::',
            'PREGUNTA_2_INDI1':'a) Your Internal IT team( has full control of the Configurations).',
            'PREGUNTA_2_INDI2':'b) I request a ticket from your provider (mention the name of the provider)',
            'PREGUNTA_3':'3.-¿Your emails are under business accounts (Gmail, Microsoft, Yahoo!, etc.)?',
            'PREGUNTA_4':'4.-¿Did you register the domain gptwonline.com, remember that the emails you receive are from this domain, ensure that they have not gone to spam or junk mail?',
            'PREGUNTA_5':'5.-¿Do you have a way to obtain a list of received emails (Email log)?',
            'PREGUNTA_6':'6.-¿What internet browsers do your collaborators have installed? (Please list; Browser - version)',
            'PREGUNTA_7':'7.-¿Did you grant the necessary permissions for your employees to navigate the survey? (If I present a problem please specify)',
            'PREGUNTA_8':'8.-¿For the application of your survey do you have computer rooms planned for your employees to answer your survey?',
            'PREGUNTA_8_INDI1':'(¿(If yes, please indicate the number of rooms and the number of equipment per room?)',
          },
          'BTN_VALIDAR_ENVIAR':'Valideren en verzenden',
        },
        'PASO5':{
          'TITULO': 'Data Privacy Policy',
          'SUB_TITULO': 'Data Privacy Policy',
          'PARRAFO1': 'De informatie die wordt verzonden en opgeslagen op de servers van het CULTURAL GO® -platform wordt beschermd en beveiligd volgens beleid en procedures die voldoen aan ISO 27001. Als u hier vragen over heeft, neem dan contact op met uw Great Place To Work®-consultant',
          'PARRAFO1_INNMO': 'De informatie die wordt verzonden en opgeslagen op de servers van het CULTURAL GO® -platform wordt beschermd en beveiligd volgens beleid en procedures die voldoen aan ISO 27001. Als u hier vragen over heeft, neem dan contact op met uw Innmotion-consultant',
          'PARRAFO2': 'Geregistreerde handelsmerken',
          'PARRAFO3_1':'- Great Place to Work® y Trust Index© ',
          'PARRAFO3_2': 'zijn geregistreerde handelsmerken van Great Place To Work Institute USA, in dit document worden deze merken alleen als referentie gebruikt',
          'PARRAFO3_1_INNMO':'- Innmotion y Trust Index© ',
          'PARRAFO3_2_INNMO': 'zijn geregistreerde handelsmerken van Innmotion Institute USA, in dit document worden deze merken alleen als referentie gebruikt',
          'PARRAFO4_1':'- Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2': 'Het is een geregistreerd handelsmerk van Innovación Tecnológica B&M S.A. de C.V. Mexico',
          'PARRAFO4_2': ' en in het algemeen het hele Go!®-platform zijn gedeponeerde handelsmerken van de ontwikkelaar.',
          'PARRAFO5': 'Dank u!!',
          'BTN_FINALIZAR': 'Voltooien en verzenden',
          'BTN_FINA_REQUE': 'Voltooide technische eisen',


        },
        'COPY_MESSAGE':'Sleutel gekopieerd naar het klembord',
        'COMPR_CONEXI':'Controle van de verbinding',
        'SUCCES_CONF_EMA':{
        'MODAL_SUCCESS':'Postontvangst is gevalideerd',
        'MODAL_INSTRUCCI':'Sluit het tabblad',
        },
        'FORMULARIO_TI': {
          'TAB': 'Einde van het proces',
          'TITULO': 'Details van de recensent',
          'SUBTITULO': 'Om het proces af te sluiten, voert u uw gegevens in het volgende formulier in en klikt u op de knop Voltooien',
          'DONE': 'Het proces is al voltooid',
          'FINALIZAR': 'Technische vereisten afronden',
          'NOTYET': 'De IT-manager heeft het proces niet voltooid, hij kan de technische vereisten bevestigen totdat de IT-manager zijn gegevens heeft ingevoerd',
          'FORM': {
            'NOMBRE': 'Naam',
            'MAIL': 'E-mail',
            'FECHA': 'Eind datum',
            'SINENVIAR': 'Gegevens nog niet verzonden'
          },
          'MENSAJES': {
            'NOMBRE': 'U heeft uw naam niet ingevuld in het aangegeven veld',
            'GUARDANDO': 'De ingevoerde informatie wordt opgeslagen, even geduld a.u.b.',
            'GUARDADO': 'De gegevens zijn correct opgeslagen'
          }
        },
          'ETI_EMPRE':'Bedrijf:',
          'CONTAC': 'Contact met ons opnemen:',
        'CONTAC_DES':'Hoe kunnen wij u helpen?',
        'SEND_EMA':'Stuur een bericht',
        'LABEL': 'Beschrijving',
        'TEX_BTN_SEND': 'Verzenden',
        'MODA_SEN_EMAI': 'Bericht verzenden...',
        'SUCC_MODA_SEN_EMAI': 'Het bericht is succesvol verzonden',

    }
  }
};
